/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidatorBlocksStatsInfo,
    ValidatorBlocksStatsInfoFromJSON,
    ValidatorBlocksStatsInfoFromJSONTyped,
    ValidatorBlocksStatsInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface ValidatorBlocksStatsResponse
 */
export interface ValidatorBlocksStatsResponse {
    /**
     * 
     * @type {Array<ValidatorBlocksStatsInfo>}
     * @memberof ValidatorBlocksStatsResponse
     */
    signs: Array<ValidatorBlocksStatsInfo>;
    /**
     * 
     * @type {Array<ValidatorBlocksStatsInfo>}
     * @memberof ValidatorBlocksStatsResponse
     */
    proposals: Array<ValidatorBlocksStatsInfo>;
}

export function ValidatorBlocksStatsResponseFromJSON(json: any): ValidatorBlocksStatsResponse {
    return ValidatorBlocksStatsResponseFromJSONTyped(json, false);
}

export function ValidatorBlocksStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatorBlocksStatsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'signs': ((json['signs'] as Array<any>).map(ValidatorBlocksStatsInfoFromJSON)),
        'proposals': ((json['proposals'] as Array<any>).map(ValidatorBlocksStatsInfoFromJSON)),
    };
}

export function ValidatorBlocksStatsResponseToJSON(value?: ValidatorBlocksStatsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'signs': ((value.signs as Array<any>).map(ValidatorBlocksStatsInfoToJSON)),
        'proposals': ((value.proposals as Array<any>).map(ValidatorBlocksStatsInfoToJSON)),
    };
}


